export enum AuthPolicyEnum {
  TrustedUser = "TrustedUser",
  ChangePassword = "ChangePassword",
  IPValidation = "IPValidation",
  RecoverPin = "RecoverPin",
  Registration = "Registration"
}